<template>
  <section class="supporters">
    <div class="page-container">
      <h2>{{supporters_headline}}</h2>
      <div v-if="$route.name === 'thankyou'" v-html="supporters_body" class="wysiwyg"></div>

      <div class="supporters-list">
        <a v-for="supporter in supporters" :key="supporter.link.url" class="supporter" :href="supporter.link.url" :target="supporter.link.target">
          <img class="supporter-img" :src="supporter.image.url" :alt="supporter.link.title">
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      supporters_headline: '',
      supporters_body: '',
      supporters: {},
    }
  },
  async mounted() {
    const optionsDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/acf/v2/options?x=1`)
    const optionsData = await optionsDataResponse.json();
    this.supporters_headline = optionsData.acf.supporters_headline;
    this.supporters_body = optionsData.acf.supporters_body;
    this.supporters = optionsData.acf.supporters;
  },
  methods: {
  }
};
</script>

<style scoped lang="less">
@import '../css/variables';

.supporters {
  background-color: #fff;
  margin: 40px 0;
  text-align: center;
  h2 {
    margin-bottom: 30px;
  }
  .wysiwyg {
    margin-bottom: 50px;
  }

  .supporters-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .supporter {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 25%;
      height: 115px;
      margin-bottom: 60px;
      padding: 0 4vw;
      @media (max-width: @mobile) {
        padding: 0 2vw;
      }
      .supporter-img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Supporters.vue